<template>
  <ui-modal
    :show="showAmount"
    type="tag"
    title="贡献奖励"
    iconType="gift_2"
    @close="hideModal()"
  >
    <div class="bonus">
      <div class="bg"></div>
    </div>
  </ui-modal>
</template>

<script>
import UiModal from "@/components/ui-modal.vue";

export default {
  components: {
    UiModal,
  },
  data() {
    return {
      showAmount: false,
    }
  },
  methods: {
    hideModal() {
      this.showAmount = false
    },
    getAmount() {
       this.showAmount = true
    }
  }
}
</script>

<style lang="scss" scoped>
.bonus{
  height: 100%;
  .bg{
    width: 1062px;
    height: 540px;
    background-image: url('https://website.xdcdn.net/poster/58881/20250717/Lncj5d5c.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 15px auto;
  }
}
</style>